<a #file (click)="download(receivedFile)">{{receivedFile.file_name}}</a>
